import { Device } from "../models/device";

export class FilterChildDevicesValueConverter {
	toView(array: Array<Device>): Array<Device> {

		if (array === undefined || array === null) {
			return null;
		}
		const filtered = array.filter((item) => item.parentId ? false : true);
		return filtered;
	}
}